<script>
  import { _ } from "svelte-i18n";
  import { HorizenLine } from "common/comp/index.js";
</script>

<div class="container mx-auto py-12 px-72">
  <p class="text-4xl font-bold mb-3">{$_("fnq.whatisnft")}</p>
  <HorizenLine width={160} />
  <p>{$_("fnq.whatisnft_paragraph1")}</p>
  <p>{$_("fnq.whatisnft_paragraph2")}</p>
  <p>{$_("fnq.whatisnft_paragraph3")}</p>
  <p>
    {$_("fnq.whatisnft_paragraph4")}
    <a href="https://opensea.io/blog/guides/non-fungible-tokens/">
      https://opensea.io/blog/guides/non-fungible-tokens/
    </a>
  </p>
  <p class="text-4xl font-bold pt-24 mb-3">{$_("fnq.whatisnftbase")}</p>
  <HorizenLine width={160} />
  <p>{$_("fnq.whatisnftbase_paragraph1")}</p>
  <p>{$_("fnq.whatisnftbase_paragraph2")}</p>
  <p>{$_("fnq.whatisnftbase_paragraph3")}</p>
  <p class="text-2xl font-bold">{$_("fnq.whatcanidowithnftbase")}</p>
  <p>{$_("fnq.whatcanidowithnftbase_paragraph1")}</p>
  <p>{$_("fnq.whatcanidowithnftbase_paragraph2")}</p>
  <p class="text-2xl font-bold">{$_("fnq.whatdoiuseforpayment")}</p>
  <p>{$_("fnq.whatdoiuseforpayment_paragraph1")}</p>
  <p class="text-2xl font-bold">{$_("fnq.iamanartist")}</p>
  <p>{$_("fnq.iamanartist_paragraph1")}</p>
  <p class="text-2xl font-bold">{$_("fnq.whatismetamask")}</p>
  <p>{$_("fnq.whatismetamask_paragraph1")}</p>

  <p class="text-2xl font-bold">{$_("fnq.isnftbasesafe")}</p>
  <p>
    {$_("fnq.isnftbasesafe_paragraph1")} <br />
    {$_("fnq.isnftbasesafe_paragraph2")}<br />
    {$_("fnq.isnftbasesafe_paragraph3")}
  </p>
  <p>{$_("fnq.isnftbasesafe_paragraph4")}</p>
  <p class="text-2xl font-bold">{$_("fnq.howcanireverse")}</p>
  <p>{$_("fnq.howcanireverse_paragraph1")}</p>
  <p class="text-2xl font-bold">{$_("fnq.iwanttobuyanitem")}</p>
  <p>{$_("fnq.iwanttobuyanitem_paragraph1")}</p>
  <p>{$_("fnq.iwanttobuyanitem_paragraph2")}</p>
  <p class="text-2xl font-bold">{$_("fnq.howdoiselldigital")}</p>
  <p>{$_("fnq.howdoiselldigital_paragraph1")}</p>

  <p class="text-2xl font-bold">{$_("fnq.iwanttomakemyfirstlisting")}</p>
  <p>{$_("fnq.iwanttomakemyfirstlisting_paragraph1")}</p>
  <p>{$_("fnq.iwanttomakemyfirstlisting_paragraph2")}</p>
  <p>{$_("fnq.iwanttomakemyfirstlisting_paragraph3")}</p>
  <p>{$_("fnq.iwanttomakemyfirstlisting_paragraph4")}</p>
  <p>{$_("fnq.iwanttomakemyfirstlisting_paragraph5")}</p>
  <p>{$_("fnq.iwanttomakemyfirstlisting_paragraph6")}</p>

  <p class="text-2xl font-bold">{$_("fnq.doesnftbasecharge")}</p>
  <p>{$_("fnq.doesnftbasecharge_paragraph1")}</p>
  <p>{$_("fnq.doesnftbasecharge_paragraph2")}</p>

  <p class="text-2xl font-bold">{$_("fnq.canisendmynft")}</p>
  <p>{$_("fnq.canisendmynft_paragraph1")}</p>

  <p class="text-2xl font-bold">{$_("fnq.ihavesuggestion")}</p>
  <p>
    {$_("fnq.ihavesuggestion_paragraph1")} :
    <a href="mailto:contact@NFTbase.ai">contact@NFTbase.ai</a><br />
    {$_("fnq.ihavesuggestion_paragraph2")} :
    <a href="mailto:service@NFTbase.ai">service@NFTbase.ai</a>
  </p>
</div>

<style>
  p {
    margin-top: 24px;
  }
</style>
